// Fax app — sub-menu clone of Number Orders that lists only the two
// fax-related order forms (`new_fax`, `port_fax`). Same underlying component
// and admin CRUD as Number Orders — filtered by category = "fax".

import { OrderFormsPage } from "@/pages/NumberOrders";

export default function Fax() {
  return (
    <OrderFormsPage
      category="fax"
      title="Fax Orders"
      subtitle="Order new fax numbers and port existing fax numbers."
      testId="fax-page"
    />
  );
}
